export const handleDate = (value: string) => {
  const date = new Date(value);
  if (value)
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  else return "N/A";
};

export const handleDateWithTime = (value: string) => {
  if (!value) return "N/A";

  const date = new Date(value);
  const now = new Date();

  // Helper to format time in AM/PM
  const formatTime = (date: Date) => {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes.toString().padStart(2, "0");
    return `${formattedHours}:${formattedMinutes} ${ampm}`;
  };

  // Get date parts
  const dateOnly = date.toDateString();
  const todayOnly = now.toDateString();

  // Calculate "Yesterday"
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  if (dateOnly === todayOnly) {
    return `Today ${formatTime(date)}`;
  } else if (dateOnly === yesterday.toDateString()) {
    return `Yesterday ${formatTime(date)}`;
  } else {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${formatTime(date)}`;
  }
};

export const handlePrice = (input: any): string => {
  const value = Number(input);

  if (input == null || isNaN(value)) return '---';

  if (value < 1000) {
    // <$1K → Round to nearest whole dollar
    return `$${value.toFixed(0)}`;
  } else if (value < 10000) {
    // $1K–$9,999 → Round to two decimal K format
    return `$${(value / 1000).toFixed(2)}K`;
  } else if (value < 1000000) {
    // $10K–$999,999 → Round to one decimal K format
    return `$${(value / 1000).toFixed(1)}K`;
  } else {
    // $1M+ → Round to two decimal M format
    return `$${(value / 1000000).toFixed(2)}M`;
  }
};

export const handleDateWithMonth = (date: string) => {
  const Month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return `${Month[Number(date.split("-")[1]) - 1]} ${date.split("-")[2]}, ${
    date.split("-")[0]
  }`;
};

export const handleTime = (time: string) => {
  return `${
    Number(time.split(":")[0]) <= 12
      ? time.split(":")[0]
      : Number(time.split(":")[0]) - 12
  }:${time.split(":")[1]} ${Number(time.split(":")[0]) <= 12 ? "AM" : "PM"}`;
};

export async function generateCodeChallenge(codeVerifier?: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await crypto.subtle.digest("SHA-256", data);

  // Convert Uint8Array to a normal array before spreading
  const base64url = btoa(String.fromCharCode(...Array.from(new Uint8Array(digest))))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

  return base64url;
}
